

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface DoctorUnavailablityParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface DoctorUnavailablity {
    id?: number;
    name: string;
    
  parameters?: DoctorUnavailablityParameter[];
  links?: any;
}

export abstract class DoctorUnavailablityData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<DoctorUnavailablity[]>;
  abstract create(url: string,data: DoctorUnavailablity): Observable<any>;
  abstract update(url: string,data: DoctorUnavailablity): Observable<any>;
  abstract delete(url: string): Observable<any>;
}